import { render, staticRenderFns } from "./gateway-statistics.vue?vue&type=template&id=f4d21b16"
import script from "./gateway-statistics.vue?vue&type=script&lang=js"
export * from "./gateway-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports